import axios from "axios";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";
import { useState, useEffect, useCallback } from "react";
import "./Weather.css";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    if (!response.data || !response.data.temperature) {
      return;
    }

    setWeatherData({
      ready: true,
      coordinates: response.data.coordinates,
      temperature: response.data.temperature?.current,
      humidity: response.data.temperature?.humidity,
      date: response.data.time ? new Date(response.data.time * 1000) : null,
      wind: response.data.wind?.speed,
      city: response.data.city,
      description: response.data.condition?.description,
      icon: response.data.condition?.icon,
    });
  }

  const search = useCallback(() => {
    const apiKey = "7e77fbbbab91e5504tfaaa75643of118";

    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;

    axios.get(apiUrl).then(handleResponse);
  }, [city]);

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  useEffect(() => {
    search();
  }, [search]);

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-9">
              <input
                type="search"
                placeholder="Enter a city..."
                className="form-control"
                value={city}
                onChange={handleCityChange}
              />
            </div>

            <div className="col-3">
              <input
                type="submit"
                value="Search"
                className="btn btn-primary w-100"
              />
            </div>
          </div>
        </form>

        <WeatherInfo data={weatherData} />

        {weatherData.coordinates && (
          <WeatherForecast coordinates={weatherData.coordinates} />
        )}
      </div>
    );
  }

  return <div className="Weather">Loading...</div>;
}
